var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":"animated zoomCustomIn","leave-active-class":"animated zoomCustomOut","mode":"out-in"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"},{name:"scroll-to",rawName:"v-scroll-to",value:('body'),expression:"'body'"}],staticClass:"scrollTo",class:[
      {
        'scrollTo--negative': _vm.$route.name === 'AboutUs' || _vm.$route.name === 'works',
        'scrollTo--fixed': _vm.isFixed,
      } ]})])}
var staticRenderFns = []

export { render, staticRenderFns }